import { Trans, useTranslation } from 'react-i18next'
import moment from 'moment'
import { useMonthlyReturnRate } from '@/application/queries'
import { Base, ReverCard, ReverLoading } from '@itsrever/design-system'
import { NoData } from '@/ui/shared'
import { ReturnsByCompensationMethodsChart } from './returns-by-compensation-methods-chart'
import { ChartMetricTabs } from './chart-metric-tabs'
import { useState } from 'react'

export const ReturnRateByMonth = () => {
  const { t } = useTranslation()

  const [chartMetric, setChartMetric] = useState<
    | 'RETURN_RATE_CHART_METRIC_UNSPECIFIED'
    | 'RETURN_RATE_CHART_METRIC_QUANTITY'
    | 'RETURN_RATE_CHART_METRIC_AMOUNT'
  >('RETURN_RATE_CHART_METRIC_QUANTITY')

  const startMonth = moment()
    .subtract(12, 'M')
    .startOf('month')
    .format('YYYY-MM-DD')

  const endMonth = moment().subtract(1, 'M').endOf('month').format('YYYY-MM-DD')

  const {
    itemsPurchasedByMonth,
    itemsReturnedByMonth,
    itemsReturnedSplitByMonth,
    returnRatesByMonth,
    monthNames,
    shopCurrency,
    loading
  } = useMonthlyReturnRate(startMonth, endMonth, chartMetric)

  const noData =
    !itemsPurchasedByMonth.length &&
    !itemsReturnedByMonth.length &&
    !returnRatesByMonth.length &&
    !monthNames.length

  return (
    <ReverCard className="h-[425px] w-full min-w-[400px] flex-1 p-3" fullWidth>
      <div className="h-full">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <p className="ml-2 mr-1">
              {t('returns_analytics.return_rate_month_split')}
            </p>
            <Base.InfoTooltip
              label={t('returns_analytics.about_return_rate_month_split')}
              content={
                <Trans
                  i18nKey="returns_analytics.chart_title_tooltip_split"
                  components={{
                    b: <b />,
                    br: <br />
                  }}
                />
              }
            />
          </div>
          <ChartMetricTabs
            selected={chartMetric}
            setSelected={setChartMetric}
          />
        </div>
        {loading ? (
          <div className="flex h-full items-center justify-center">
            <ReverLoading />
          </div>
        ) : noData ? (
          <NoData />
        ) : (
          <ReturnsByCompensationMethodsChart
            itemsPurchased={itemsPurchasedByMonth}
            itemsReturned={itemsReturnedSplitByMonth}
            names={monthNames}
            chartMetric={chartMetric}
            currency={shopCurrency}
          />
        )}
      </div>
    </ReverCard>
  )
}
